import useSearch from '@/hooks/search/useSearch'
import { useFeedStore } from '@/stores/feed/feedStore'
import { useSearchStore } from '@/stores/feed/searchStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { FormattedFeedProductType } from '@/types'

import cn from './ProductArt.module.scss'

function ProductArt({ product }: { product: FormattedFeedProductType }) {
  const {
    currentlySearchableBrands,
    currentlySearchableCategories,
    currentlySearchableCharacteristics,
    withLeftovers,
    setSearchTerm,
  } = useSearchStore((state) => state)

  const { selectedOrganisation } = useUserInfoStore((state) => state)

  const { setProductsLoading } = useFeedStore((state) => state)

  const search = useSearch()

  const handleSearchByArticle = (e: React.MouseEvent) => {
    e.stopPropagation()

    if (product.parent) {
      setProductsLoading(true)
      setSearchTerm(product.nomenclatureDto.article)
      search({
        query: product.nomenclatureDto.article,
        categories: currentlySearchableCategories,
        brands: currentlySearchableBrands,
        page: 0,
        characteristicFilters: currentlySearchableCharacteristics,
        withLeftovers: withLeftovers,
      })
    }
  }

  return (
    <span
      className={
        Object.keys(selectedOrganisation).length
          ? [cn.productArt, cn.organisationSelected].join(' ')
          : cn.productArt
      }
      onClick={handleSearchByArticle}
    >
      {product.parent && product.nomenclatureDto.article}
    </span>
  )
}

export default ProductArt
